'use strict';

/* Expose. */
module.exports = visitParents;

/* Visit. */
function visitParents(tree, type, visitor) {
  var stack = [];
  if (typeof type === 'function') {
    visitor = type;
    type = null;
  }
  one(tree);

  /* Visit a single node. */
  function one(node) {
    var result;
    if (!type || node.type === type) {
      result = visitor(node, stack.concat());
    }
    if (node.children && result !== false) {
      return all(node.children, node);
    }
    return result;
  }

  /* Visit children in `parent`. */
  function all(children, parent) {
    var length = children.length;
    var index = -1;
    var child;
    stack.push(parent);
    while (++index < length) {
      child = children[index];
      if (child && one(child) === false) {
        return false;
      }
    }
    stack.pop();
    return true;
  }
}
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/atlassian/pipelines/agent/build/node_modules/unist-util-visit-parents/index.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/opt/atlassian/pipelines/agent/build/node_modules/unist-util-visit-parents/index.js");
  }
}();